class APIS {
	apis() {
		return {
			inboundCounts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/inbound/counts'
			},
			outboundCounts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/outbound/counts'
			}
		};
	}
}

export default new APIS();
